module.exports = __webpack_public_path__ + "static/Image_Asset_2-345f11cc807b0b1f4840be5af04d5304.gif";